module.exports = __webpack_public_path__ + "static/media/setupcalculatoricon.199e7929.svg";